// extracted by mini-css-extract-plugin
module.exports = {"layout":"image-gallery_layout__8pLFP"};